import React, { useState, useEffect } from "react";
import EditProtocolField from "../protocol/EditProtocolField"; // Assuming path

const ActiveModuleEditor = ({ activeModule, onUpdate }) => {
  const [moduleId, setModuleId] = useState("");
  const [triggerReason, setTriggerReason] = useState("");
  const [isFromProtocol, setIsFromProtocol] = useState(false);

  useEffect(() => {
    if (activeModule) {
      setModuleId(activeModule.module_id || "");
      setTriggerReason(activeModule.trigger_reason || "");
      setIsFromProtocol(activeModule.is_from_protocol || false);
    }
  }, [activeModule]);

  const handleUpdate = (field, value) => {
    const updatedModule = {
      ...(activeModule || {}),
      [field]: value,
    };
    // Update local state immediately for responsiveness
    if (field === "module_id") setModuleId(value);
    if (field === "trigger_reason") setTriggerReason(value);
    if (field === "is_from_protocol") setIsFromProtocol(value);

    onUpdate(updatedModule);
  };

  if (!activeModule) {
    return <p className="text-slate-500">No active module to edit.</p>;
  }

  return (
    <div className="space-y-4 p-4 border border-slate-200 rounded-lg">
      <h3 className="text-lg font-medium text-slate-700">Edit Active Module</h3>

      <div>
        <label
          htmlFor="module_id"
          className="block text-sm font-medium text-slate-700 mb-1"
        >
          Module ID
        </label>
        <EditProtocolField
          value={moduleId}
          onChange={(e) => handleUpdate("module_id", e.target.value)}
          placeholder="Enter module ID"
        />
      </div>

      <div>
        <label
          htmlFor="trigger_reason"
          className="block text-sm font-medium text-slate-700 mb-1"
        >
          Trigger Reason
        </label>
        <textarea
          id="trigger_reason"
          value={triggerReason}
          onChange={(e) => handleUpdate("trigger_reason", e.target.value)}
          className="border border-slate-300 rounded py-2 px-4 w-full mt-1"
          placeholder="Enter trigger reason"
          rows={3}
        />
      </div>

      <div className="flex items-center">
        <input
          id="is_from_protocol"
          type="checkbox"
          checked={isFromProtocol}
          onChange={(e) => handleUpdate("is_from_protocol", e.target.checked)}
          className="h-4 w-4 text-blue-600 border-slate-300 rounded focus:ring-blue-500"
        />
        <label
          htmlFor="is_from_protocol"
          className="ml-2 block text-sm text-slate-700"
        >
          Is from protocol
        </label>
      </div>
    </div>
  );
};

export default ActiveModuleEditor;
